export type Rating = {
  id: string
  conversation_id: string
  tenant_id: string
  tenant_name: string | null
  user_id: string
  user_name: string
  response_text: string
  thumbs_up: boolean
  rationale: string | null
  created_at: string
}

export type RatingListResponse = {
  items: Rating[]
  limit: number
  offset: number
  total: number
}

export type ThumbsFilter = 'any' | 'up' | 'down'

export type RatingFilters = {
  conversationId?: string
  tenantId?: string
  userId?: string
  thumbs: ThumbsFilter
  q?: string
  page: number
  pageSize: number
}

export const RATINGS_PAGE_SIZE = 25

export function getDefaultRatingFilters(): RatingFilters {
  return {
    thumbs: 'any',
    page: 1,
    pageSize: RATINGS_PAGE_SIZE,
  }
}

export function buildRatingsListQuery(filters: RatingFilters): URLSearchParams {
  const query = new URLSearchParams()
  if (filters.conversationId) {
    query.set('conversation_id', filters.conversationId)
  }
  if (filters.tenantId) {
    query.set('tenant_id', filters.tenantId)
  }
  if (filters.userId) {
    query.set('user_id', filters.userId)
  }
  if (filters.thumbs === 'up') {
    query.set('thumbs_up', 'true')
  } else if (filters.thumbs === 'down') {
    query.set('thumbs_up', 'false')
  }
  if (filters.q) {
    query.set('q', filters.q)
  }
  query.set('limit', String(filters.pageSize))
  query.set('offset', String((filters.page - 1) * filters.pageSize))
  return query
}
